import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { CDN_URL } from './constants';

const ThemeAssets = ({ onReady }) => {
  useEffect(() => {
    const urls = [
      `${CDN_URL}/parki/app_theme/assets/vendor/fonts/iconify-icons.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/libs/node-waves/node-waves.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/css/core.css`,
      `${CDN_URL}/parki/app_theme/assets/css/demo.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/libs/@form-validation/form-validation.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/css/pages/page-auth.css`,
      `${CDN_URL}/parki/app_theme/assets/vendor/css/theme-default.css`,
    ];

    let remaining = urls.length;
    const links = [];

    const done = () => {
      remaining -= 1;
      if (remaining <= 0) {
        // Also wait for webfonts if supported (non-blocking timeout guard)
        const finish = () => onReady && onReady();
        if (document.fonts && document.fonts.ready) {
          const timer = setTimeout(finish, 1500);
          document.fonts.ready.finally(() => {
            clearTimeout(timer);
            finish();
          });
        } else {
          finish();
        }
      }
    };

    urls.forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = done;
      link.onerror = done; // don't block app if a single file fails
      document.head.appendChild(link);
      links.push(link);
    });

    return () => {
      // Optional cleanup if this component unmounts early
      // links.forEach(l => l.parentNode && l.parentNode.removeChild(l));
    };
  }, [onReady]);

  return (
    <Helmet>
      {/* Favicon */}
      <link
        rel="icon"
        type="image/x-icon"
        href={`${CDN_URL}/parki/logo/Logo+files/Favicon/32x32/1-01.png`}
      />
      {/* Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
};

export default ThemeAssets;